export enum RunningTradeCustomFilterActionEnum {
  ALL = 0,
  BUY = 1,
  SELL = 2,
}

export interface RunningTradeCustomFilter {
  minPrice?: number | null;
  maxPrice?: number | null;
  minPercentage?: number | null;
  maxPercentage?: number | null;
  minLot?: number | null;
  actionType?: RunningTradeCustomFilterActionEnum;
  timeRangeStart?: string | null;
  timeRangeEnd?: string | null;
}

export type ActiveStockFilterType = 'allstock' | 'custom' | 'watchlist' | null;

export enum StockFilterTypeEnum {
  Custom = 'custom',
  AllStock = 'allstock',
  Watchlist = 'watchlist',
}

export type StockFilterCustomType = {
  type: StockFilterTypeEnum.Custom;
  selected?: string[];
}

export type StockFilterAllType = {
  type: StockFilterTypeEnum.AllStock;
  selected?: string[];
}

export type StockFilterWatchlistType = {
  type: StockFilterTypeEnum.Watchlist;
  watchlistName: string;
  watchlistId: string;
  watchlistItemCounts?: number;
  selected?: string[];
}

export type RunningTradeStockFilter =
  StockFilterCustomType | StockFilterAllType | StockFilterWatchlistType;
